import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "previewContent", "confirmButton"]
  static values = { patientId: String }

  connect() {
    document.addEventListener("show-invoice-preview", this.handleShowPreview.bind(this))
  }

  disconnect() {
    document.removeEventListener("show-invoice-preview", this.handleShowPreview.bind(this))
  }

  handleShowPreview(event) {
    this.form = event.detail.form
    this.openModal()
    this.loadPreview()
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.previewContentTarget.innerHTML = ""
  }

  async loadPreview() {
    const formData = new FormData(this.form)
    const params = new URLSearchParams(formData)
    const url = `/receptionist/cash/${this.patientIdValue}/preview_payment.html?${params}`

    this.confirmButtonTarget.disabled = true
    this.previewContentTarget.innerHTML = '<div class="flex items-center justify-center py-12"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>'

    try {
      const response = await fetch(url)
      if (response.ok) {
        const html = await response.text()
        this.previewContentTarget.innerHTML = html
      } else {
        this.previewContentTarget.innerHTML = '<p class="text-red-600 py-8 text-center">No se pudo cargar la vista previa. Intente de nuevo.</p>'
      }
    } catch (error) {
      this.previewContentTarget.innerHTML = '<p class="text-red-600 py-8 text-center">Error al cargar la vista previa. Intente de nuevo.</p>'
    } finally {
      this.confirmButtonTarget.disabled = false
    }
  }

  confirmPayment() {
    this.closeModal()
    this.form.submit()
  }
}

